import { render, staticRenderFns } from "./ToolPanelLabel.vue?vue&type=template&id=4dbc3bb9&"
import script from "./ToolPanelLabel.vue?vue&type=script&lang=js&"
export * from "./ToolPanelLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports